module.exports = __webpack_public_path__ + "static/media/programa_mas_informados.824a1fd4.gif";